export interface RoleFormState {
    name: string;
    users: number[];
}
